module.exports = __webpack_public_path__ + "img/border-black.05a42568.png";